import client from "../client";

export interface CreateRoomRequest {
  prefix?: string;
  username?: string;
}

export default function API(request: CreateRoomRequest) {
  return client
    .post(`chat/create_room`, request)
    .then((response) => response.data);
}
